import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockCheckSpaceExists,
  mockRandomSpaceAccessConfig,
} from "./HomeMock";
import type { RandomSpaceAccessPublicConfig } from "./HomeModel";

const ping = (): Promise<Record<string, unknown> | string> =>
  post<Record<string, never>, Record<string, unknown>>("/api/ping", {});

const checkSpaceExists = async (spaceId: string): Promise<boolean> => {
  if (useLongfansMock) {
    return mockCheckSpaceExists(spaceId);
  }
  const res = await post<{ spaceId: string }, { exists: boolean }>(
    "/lark/app/space/checkSpaceExists",
    { spaceId },
    { silent: true }
  );
  if (typeof res === "string") {
    return false;
  }
  return !!res?.exists;
};

const getRandomSpaceAccessConfig = async (): Promise<RandomSpaceAccessPublicConfig> => {
  if (useLongfansMock) {
    return mockRandomSpaceAccessConfig;
  }
  const res = await post<Record<string, never>, RandomSpaceAccessPublicConfig>(
    "/lark/app/home/getRandomSpaceAccessConfig",
    {},
    { silent: true }
  );
  if (typeof res === "string") {
    return { enabled: false, candidates: [], bigButton: false, buttonText: "" };
  }
  return {
    enabled: !!res?.enabled,
    candidates: Array.isArray(res?.candidates) ? res.candidates : [],
    bigButton: !!res?.bigButton,
    buttonText: typeof res?.buttonText === "string" ? res.buttonText : "",
  };
};

export const HomeApi = {
  ping,
  checkSpaceExists,
  getRandomSpaceAccessConfig,
};
